import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switch_role_personal",
  "use": "icon-switch_role_personal-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 31\" id=\"icon-switch_role_personal\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3-2h36v36H-3z\" /><path d=\"M7.5 6.5V2A1.5 1.5 0 0 1 9 .5h12A1.5 1.5 0 0 1 22.5 2v4.5h6A1.5 1.5 0 0 1 30 8v21a1.5 1.5 0 0 1-1.5 1.5h-27A1.5 1.5 0 0 1 0 29V8a1.5 1.5 0 0 1 1.5-1.5h6ZM3 23v4.5h24V23H3Zm0-3h24V9.5H3V20Zm7.5-16.5v3h9v-3h-9Zm3 12h3v3h-3v-3Z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol